import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const PendingIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
        <g data-name="Group 17213">
          <g data-name="Group 17205">
            <path
              data-name="Path 18368"
              d="M14.5 0A14.5 14.5 0 1 1 0 14.5 14.5 14.5 0 0 1 14.5 0z"
              fill="currentColor"
            />
          </g>
          <g data-name="Group 17207">
            <g data-name="Group 17206" transform="translate(5.314 12.381)">
              <circle data-name="Ellipse 726" cx="2.118" cy="2.118" r="2.118" fill="#fff" />
            </g>
          </g>
          <g data-name="Group 17209">
            <g data-name="Group 17208" transform="translate(12.381 12.381)">
              <circle data-name="Ellipse 727" cx="2.118" cy="2.118" r="2.118" fill="#fff" />
            </g>
          </g>
          <g data-name="Group 17211">
            <g data-name="Group 17210" transform="translate(19.448 12.381)">
              <circle data-name="Ellipse 728" cx="2.118" cy="2.118" r="2.118" fill="#fff" />
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
});
